import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/invest/alena.png'
import _imports_1 from '@/assets/invest/natalia.png'
import _imports_2 from '@/assets/invest/alexander.png'
import _imports_3 from '@/assets/invest/worldwide.png'
import _imports_4 from '@/assets/invest/mapp.png'


const _withScopeId = n => (_pushScopeId("data-v-65ed518c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest" }
const _hoisted_2 = { class: "invest__hero" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Inkast", -1))
const _hoisted_4 = { class: "invest__hero-line" }
const _hoisted_5 = { class: "invest__hero-stuff" }
const _hoisted_6 = { class: "stuff" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Alena"
}, null, -1))
const _hoisted_8 = { class: "stuff-info" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CEO", -1))
const _hoisted_11 = { class: "stuff" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Natalia"
}, null, -1))
const _hoisted_13 = { class: "stuff-info" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "CTO", -1))
const _hoisted_16 = { class: "stuff" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Alexander"
}, null, -1))
const _hoisted_18 = { class: "stuff-info" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "COO", -1))
const _hoisted_21 = { class: "invest-us" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://t.me/alencombo",
  target: "_blank"
}, "tg: @alencombo", -1))
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "invest__root-case" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "root-case__explanation" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "root-case__details" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "invest__mvp" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Minimum Viable Product", -1))
const _hoisted_32 = { class: "invest__legenda" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = { class: "invest__mvp-map" }
const _hoisted_36 = ["src"]
const _hoisted_37 = ["innerHTML"]
const _hoisted_38 = { class: "invest__conclusions" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest__country" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "dmap",
    src: _imports_3,
    alt: "worldwide"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "mmap",
    src: _imports_4,
    alt: "worldwide mobile"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Navbar),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("a", {
                  href: "https://t.me/alencombo",
                  innerHTML: _ctx.t('Investors.hero.CEO'),
                  target: "_blank"
                }, null, 8, _hoisted_9),
                _hoisted_10
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("a", {
                  href: "https://t.me/nmaltseva",
                  innerHTML: _ctx.t('Investors.hero.CTO'),
                  target: "_blank"
                }, null, 8, _hoisted_14),
                _hoisted_15
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("a", {
                  href: "https://t.me/greeneboy",
                  innerHTML: _ctx.t('Investors.hero.COO'),
                  target: "_blank"
                }, null, 8, _hoisted_19),
                _hoisted_20
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("span", {
                innerHTML: _ctx.t('Investors.hero.contacts')
              }, null, 8, _hoisted_23)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_24, [
        _createElementVNode("h2", {
          innerHTML: _ctx.t('Investors.rootcase.title')
        }, null, 8, _hoisted_25),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h4", {
            innerHTML: _ctx.t('Investors.rootcase.leadtext')
          }, null, 8, _hoisted_27),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("p", {
              innerHTML: _ctx.t('Investors.rootcase.text')
            }, null, 8, _hoisted_29),
            _createVNode(_component_router_link, {
              to: _ctx.language_link,
              class: "invest__presentation",
              innerHTML: _ctx.t('Investors.rootcase.button')
            }, null, 8, ["to", "innerHTML"])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", {
            innerHTML: _ctx.t('Investors.mvp.legenda01')
          }, null, 8, _hoisted_33),
          _createElementVNode("span", {
            innerHTML: _ctx.t('Investors.mvp.legenda02')
          }, null, 8, _hoisted_34)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("img", {
            src: 
            require(`@/assets/invest/map/${_ctx.t(
              'Investors.mvp.mvpmap.image'
            )}.svg`)
          ,
            alt: ""
          }, null, 8, _hoisted_36)
        ]),
        _createElementVNode("div", {
          class: "invest__footnote",
          innerHTML: _ctx.t('Investors.mvp.footnote')
        }, null, 8, _hoisted_37)
      ]),
      _createElementVNode("section", _hoisted_38, [
        _createElementVNode("h2", {
          innerHTML: _ctx.t('Investors.conclusions.title')
        }, null, 8, _hoisted_39),
        _createElementVNode("p", {
          innerHTML: _ctx.t('Investors.conclusions.description')
        }, null, 8, _hoisted_40)
      ]),
      _hoisted_41
    ])
  ], 64))
}